<section class="flex-col title__section">
  <h2 class="heading-4" data-testid="model-number-heading-text">
    {{ vm.modelNumberRequired ? 'Find' : 'Enter' }} your model number
  </h2>
  <div data-testid="model-number-subheading-text">
    <p class="body">You'll see this number on a plate or sticker on your {{ vm.applianceDescription }}.</p>
    @if (!vm.isTelevision && vm.modelNumberRequired) {
      <p class="body">Search for the number, then select it from the list.</p>
    }
  </div>
</section>

@if (vm.useBVModelLookup) {
  <section class="text-search__section">
    <app-text-search
      #bvModelNumberLookup
      textInputClasses="max-w-332"
      name="modelNumber"
      label="Model number search"
      placeHolder="Enter 3 characters to search"
      selectedLabel="Your number"
      searchIconPosition="start"
      [ngModel]="vm.formValue?.['modelNumber']"
      [useBVSearch]="vm.bvModelNumberLookupData"
      [initialApiError]="apiLookupError()"
      (searchTermChanged)="bvModelNumberLookup.apiError() ? setStaticValue($event) : null"
      [errors]="vm.formSubmitted ? (vm.errors['section'] | stringify: true) : undefined"
      (apiLookupError)="apiLookupError.set($event); setModelNumberError(); handleFormValidation()"
    >
      <span api-error-description data-testid="api-error">Please enter your model number manually and continue.</span>
      <span no-results-description data-testid="model-number-not-found-error"
        >Double-check the number on your product, try again and select from the list.</span
      >

      <section errors-content>
        @if (vm.errors['section']?.['required'] && vm.formSubmitted) {
          <div class="error flex gap-8 mt-8">
            <i class="fa-light fa-circle-exclamation"></i>

            <p class="body" data-testid="model-number-empty-error">Please enter a model number</p>
          </div>
        }
      </section>
    </app-text-search>
  </section>
} @else if (vm.modelNumberRequired) {
  <section class="text-search__section">
    <app-text-search
      textInputClasses="max-w-332"
      name="modelNumber"
      label="Model number search"
      placeHolder="Enter 3 characters to search"
      selectedLabel="Your number"
      searchIconPosition="start"
      [ngModel]="vm.formValue?.['modelNumber']"
      [useOrbitSearch]="inputConfig['ModelNumber']"
      [errors]="vm.formSubmitted ? (vm.errors['section'] | stringify: true) : undefined"
      (apiLookupError)="apiLookupError.set($event)"
    >
      <span api-error-description data-testid="api-error">Please enter your model number manually and continue.</span>
      <span no-results-description data-testid="model-number-not-found-error"
        >Double-check the number on your product, try again and select from the list.</span
      >

      <section errors-content>
        @if (this.vm.errors['section']?.['required'] && vm.formSubmitted) {
          <div class="error flex gap-8 mt-8">
            <i class="fa-light fa-circle-exclamation"></i>

            <p class="body" data-testid="model-number-empty-error">Please enter a model number</p>
          </div>
        }
      </section>
    </app-text-search>
  </section>
} @else {
  <section>
    <app-text-input
      class="max-w-332"
      name="modelNumber"
      label="Model number"
      [ngModel]="vm.formValue?.['modelNumber']"
    ></app-text-input>
    <p class="hint mt-4" data-testid="model-number-hint">For example ABC123456789</p>
  </section>
}

<section class="flex-col gap-8" data-testid="model-number-reason">
  <p class="label">Why do we need this?</p>

  <ul class="why-do-we-need-this flex-col gap-8">
    @for (check of vm.whyDoWeNeedThisCheckList; track check) {
      <li class="body">
        <i class="fa-light fa-check mt-4"></i>
        {{ check }}
      </li>
    }
  </ul>
</section>

<section class="panel" [class.open]="vm.panelExpanded">
  <section class="header">
    <button
      type="button"
      class="label flex gap-8 body large"
      (click)="panelExpanded.set(!vm.panelExpanded); trackClick()"
      data-testid="where-to-find-model-number"
    >
      <span> Where to find the number </span>

      <i class="fa-regular" [class.fa-chevron-up]="vm.panelExpanded" [class.fa-chevron-down]="!vm.panelExpanded"></i>
    </button>
  </section>

  <section [appAnimateOpen]="vm.panelExpanded" class="content">
    <section class="flex-col gap-8 full-width mt-8" data-testid="find-model-number-advice">
      <ul class="where-to-find flex-col gap-8">
        @for (item of vm.whereToFindItems; track item) {
          <li class="body">{{ item }}</li>
        }
      </ul>

      @if (vm.brandImage) {
        <img [src]="'assets/images/model-number-diagrams/' + vm.brandImage" alt="" />
      }

      @if (vm.showGenericModelNumberBox) {
        <label class="checkbox" for="cannot-find-number">
          <input
            type="checkbox"
            id="cannot-find-number"
            name="cannot-find-number"
            class="cannot-find-number-checkbox"
            [ngModel]="vm.formValue?.['cannot-find-number']"
            (ngModelChange)="trackClick()"
            (keydown)="onCheckboxKeydown($event, vm.formValue?.['cannot-find-number'])"
            data-testid="cannot-find-number-checkbox"
          />
          <span class="box">
            <svg
              class="checkmark"
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="13"
              viewBox="0 0 17 13"
              fill="none"
            >
              <path
                d="M14.3779 1.5957C14.921 1.07338 15.7987 1.07344 16.3418 1.5957C16.3486 1.60222 16.3535 1.61105 16.3594 1.61816C16.8863 2.14774 16.8801 2.99272 16.3389 3.51367L7.19629 12.3125C6.65317 12.8347 5.77546 12.8349 5.23242 12.3125L0.661133 7.91309C0.112572 7.38512 0.112572 6.52308 0.661133 5.99512C1.20428 5.47241 2.0828 5.47245 2.62598 5.99512L6.21582 9.44727L14.3779 1.5957Z"
                fill="#0065C4"
                stroke="#0065C4"
                stroke-width="0.5"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span class="cannot-find-number-text label">I still can't find the number</span>
        </label>
      }
    </section>
  </section>

  <div>
    <div class="divider"></div>
  </div>

  @if (apiLookupError()) {
    <p class="body mb-24 md-mt-16" data-testid="model-api-error-message">
      You can continue without adding a model number - but this may affect your repair and number of required engineer
      visits.
    </p>
  }

  @if (
    (confirmBlankModelNumber() && !vm.formValue?.['modelNumber']) ||
    (vm.formValue?.['cannot-find-number'] && vm.panelExpanded)
  ) {
    <section class="number-is-important p-16 mb-16 flex-col gap-8" data-testid="blank-model-number-warning">
      <p class="label">
        <i class="fa-light fa-circle-exclamation"></i>
        This number is important
      </p>

      <p class="body">It allows us to:</p>

      <ul class="flex-col gap-8">
        @for (point of vm.numberIsImportantPoints; track point) {
          <li class="body">{{ point }}</li>
        }
      </ul>

      <p class="body" [innerHTML]="vm.numberIsImportantFinalLine"></p>
    </section>
  }
</section>
